import React from "react";
import ReactDOM from "react-dom";
import "./style/Global.js";
import App from "./App";
// import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("root"));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js